export function getAll() {
  return [
    {
      value: 0,
      name: "DiscountAndFreePrice",
      text: "一般",
    },
    {
      value: 1,
      name: "IncludeChangePrice",
      text: "改變售價別",
    },
  ];
}
